import { render } from "./ShowCase.vue?vue&type=template&id=3c8cd345&scoped=true"
import script from "./ShowCase.vue?vue&type=script&lang=js"
export * from "./ShowCase.vue?vue&type=script&lang=js"

import "./ShowCase.vue?vue&type=style&index=0&id=3c8cd345&lang=scss&scoped=true"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8cd345"]])

export default __exports__